<template>
  <section :id="`comp_id_${compProps.elementId}`" :key="keyName">
    <component :is="compName" :compProps="uiProps" @action="actionHandle" @reload="reload"></component>
    <component :is="servCompName" :payLoad="payLoad" :compProps="compProps" :compIndex="compIndex" @init="initHandle" @finish="finishHandle"></component>
  </section>
</template>
<script>
import HouseFilter from '@/components/HouseFilter'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'

export default {
  mixins: [mixin],
  data() {
    return {
      uiProps: {
        ...this.compProps,
        allCityConfig: {
          hotCityList: [],
          fixedIndexList: [],
          cityList: []
        },
        timeStamp: 0
      },
      payLoad: null
    }
  },
  components: {
    HouseFilter,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    compName() {
      return 'HouseFilter'
    },
    keyName() {
      return this.$root.promotionId + this.compProps.elementId + ''
    }
  },
  methods: {
    /**
     * 初始化接口，用于获得业务组件的初始化数据
     */
    initHandle(payload) {
      this.uiProps = {
        ...this.compProps,
        allCityConfig: payload.allCityConfig,
        timeStamp: new Date().getTime()
      }
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payload) {
      this.payLoad = {
        ...payload,
        timeStamp: new Date().getTime()
      }
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle(payLoad) {
    },
    reload(activityId, redirect) {
      this.$emit('reload', activityId, redirect)
    }
  }
}
</script>
